import { useState } from 'react';
import { MenuItem, Select as MSelect, type SelectChangeEvent } from '@mui/material';

import { ReactComponent as ArrowDown } from '../../../assets/arrow-down.svg';

export interface Item {
  value: string;
  label: string;
}

export default function Select ({
  menuItems,
  value,
  onChange,
}: {
  menuItems: Item[];
  value: string;
  onChange: (value: string) => void;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const handleChange = (e: SelectChangeEvent) => {
    const newValue = e.target.value;
    onChange(newValue);
  };

  const iconDropdown = () => {
    return (
      <div
        style={{
          minWidth: '40px',
          backgroundColor: '#006EC2',
          borderRadius: '2px',
          height: '40px',
          display: 'flex',
          justifyContent: 'center',
        }}
        onClick={() => { setIsOpen(prev => !prev); }}
      >
        <ArrowDown width="12" />
      </div>
    );
  };

  return (
    <MSelect
      value={value}
      onChange={handleChange}
      IconComponent={iconDropdown}
      open={isOpen}
      onOpen={() => { setIsOpen(true); }}
      onClose={() => { setIsOpen(false); }}
    >
      {menuItems.map(item => (
        <MenuItem key={item.value} value={item.value}>
          {item.label}
        </MenuItem>
      ))}
    </MSelect>
  );
}
